import { useEffect, useState } from 'react';
import { googleMapsApiSettings } from '@/services/googleMapsApiSettings';

export function useGoogleMapsEnabled(): boolean {
  const [enabled, setEnabled] = useState(googleMapsApiSettings.getUseGoogleMaps());
  useEffect(() => googleMapsApiSettings.subscribe(setEnabled), []);
  return enabled;
}

export function useGoogleMapsLoader(): { isLoaded: boolean; loadError?: Error; enabled: boolean } {
  const enabled = useGoogleMapsEnabled();
  const [apiKey, setApiKey] = useState(googleMapsApiSettings.getApiKey());
  const [isLoaded, setIsLoaded] = useState(googleMapsApiSettings.isLoaded());
  const [loadError, setLoadError] = useState<Error | undefined>();

  useEffect(() => {
    const unsubKey = googleMapsApiSettings.subscribeApiKey(setApiKey);
    const unsubLoaded = googleMapsApiSettings.subscribeLoaded(setIsLoaded);
    return () => {
      unsubKey();
      unsubLoaded();
    };
  }, []);

  useEffect(() => {
    if (!enabled || !apiKey) {
      if (enabled && !apiKey) {
        setLoadError(new Error('Google Maps API key is not configured.'));
      }
      return;
    }

    setLoadError(undefined);
    let active = true;
    googleMapsApiSettings
      .load()
      .catch((err: unknown) => {
        if (!active) return;
        setLoadError(err instanceof Error ? err : new Error(String(err)));
      });
    return () => {
      active = false;
    };
  }, [enabled, apiKey]);

  return { isLoaded, loadError, enabled };
}
